module.exports = __webpack_public_path__ + "img/intro.8bd5b02a.png";